export const dashboardSeriesColors = [
  'hsl(var(--chart-1))',
  'hsl(var(--chart-2))',
  'hsl(var(--chart-3))',
  'hsl(var(--chart-4))',
  'hsl(var(--chart-5))',
] as const;

export function getDashboardSeriesColor(index: number): string {
  return dashboardSeriesColors[index % dashboardSeriesColors.length] ?? dashboardSeriesColors[0];
}

export function getDashboardHealthTone(
  summary:
    | {
        callsTotal: number;
        errorCalls: number;
      }
    | undefined,
): 'success' | 'warning' | 'destructive' {
  if (!summary || summary.callsTotal === 0) return 'success';

  const errorRate = summary.errorCalls / summary.callsTotal;
  if (errorRate >= 0.12) return 'destructive';
  if (errorRate >= 0.05) return 'warning';
  return 'success';
}
